<template>
    <div class="page" id="messages">
        <header class="pageHeader">
            <fade-image src="assets/headers/messages.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Messages</h1>
                <img class="icon" src="~@/assets/icons/headers/messages.svg" />
            </div>

            <div v-if="latestMessage">
                <h2 class="title" style="margin-bottom: 20px">Latest message:</h2>

                <router-link
                    class="latestMessage"
                    :to="{
                        name: 'playerMessage',
                        params: { id: latestMessage.id },
                        query: { from: 'messages' },
                    }"
                    :class="{ read: !latestMessage.read }"
                >
                    <header>
                        <span class="from"
                            >{{ latestMessage.from.first_name }}
                            {{ latestMessage.from.last_name }}</span
                        >
                        <span class="date">{{
                            $date(latestMessage.created_at).format("D MMM YYYY")
                        }}</span>
                    </header>

                    <div class="copy">
                        <p>{{ latestMessage.short_message }}</p>
                    </div>
                </router-link>
            </div>

            <router-link class="button" :to="{ name: 'playerMessagesAll' }"
                >View all messages
                <chevron-right-icon class="icon"></chevron-right-icon>
            </router-link>

            <!--<router-link class="button dark" to="/">Message settings
                  <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>-->
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { ChevronRightIcon } from "vue-feather-icons";
export default {
    name: "player-messages",
    components: { FadeImage, ChevronRightIcon },
    data() {
        return {
            latestMessage: false,
        };
    },
    created() {
        this.getMessage();
    },
    methods: {
        getMessage() {
            window.axios.get("/message").then((response) => {
                if (response.data.length > 0) {
                    this.latestMessage = response.data[0];
                }
            });
        },
    },
};
</script>

<style lang="scss">
#messages {
    .button {
        margin-bottom: 10px;
    }
    .title {
        margin-top: 10px;
    }

    .latestMessage {
        background: $grey;
        padding: 17px;
        border-radius: 12px;
        margin-bottom: 20px;
        display: block;
        text-decoration: none;

        &.read {
            border-left: 5px solid #60c45c;
        }

        header {
            color: $green_0;
            margin-bottom: 10px;
            .title {
                font-weight: bold;
            }
            .date {
                float: right;
                color: #cccccc;
            }
        }
        .copy {
            color: $green_0;
            font-weight: 200;
        }
    }
}
</style>
